import Modal, { ModalProps } from "../Modal/Modal";
import Driver from "../Order/Driver";
import { useModalMeta } from "@/shared/atoms/useModal";

const AssignCourierModal = ({ onExit, ...props }: ModalProps) => {
  const [{ initialDriver, order, onCourierUpdated }] = useModalMeta();

  return (
    <Modal onExit={onExit} {...props}>
      <Driver
        initialDriver={initialDriver}
        order={order}
        onAssignedOrUnassigned={() => {
          onCourierUpdated?.();
          onExit();
        }}
      />
    </Modal>
  );
};
export default AssignCourierModal;
